import { ISite } from '../../../shared/models';
import { createHTTPActions } from '../utils';

export enum ESitesActions {
  getAllSites = '[Sites] Get Sites',
}

const [getAllSites, getSitesSuccess, getSitesError] = createHTTPActions<void, ISite[], Error>(
  ESitesActions.getAllSites,
);

export const SITES_ACTIONS = {
  getAllSites,
  getSitesSuccess,
  getSitesError,
};
